(function () {

  // --- Color swatches for product types ---
  const OBSERVER_IDLE_TIMEOUT = 3000; // ms to wait with no DOM mutations before disconnecting

  const typeCache = new Map();

  async function renderSwatchesForHolder(swatchHolder) {
    // Prevent duplicate rendering for the same element
    if (!swatchHolder || swatchHolder.dataset.swatchesLoaded === "true") return;
    swatchHolder.dataset.swatchesLoaded = "true";

    const productType = swatchHolder.dataset.productType;
    const currentHandle = swatchHolder.dataset.productHandle;
    const list = swatchHolder.querySelector("ul");

    if (!productType || !list) return;

    try {
      let data = typeCache.get(productType);
      if (!data) {
        const url = `${window.location.origin}/search?q=product_type:${encodeURIComponent(productType)}&type=product&view=color-json`;
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch swatches");
        data = await response.json();
        typeCache.set(productType, data);
      }

      data.forEach(prod => {
        const color = prod.color;
        if (!color) return;

        const colorHandle = color.toLowerCase().replace(/\s+/g, "-").replace(/\//g, "-");
        const isActive = prod.handle === currentHandle;

        const li = document.createElement("li");
        if (isActive) li.classList.add("active");

        li.innerHTML = `
          <a href="${prod.url}" title="${prod.title} - ${color}">
            <span class="color-swatch color-swatch--${colorHandle}" 
                  style="background: var(--color_${colorHandle});"
                  title="${color}">
            </span>
          </a>
        `;
        list.appendChild(li);
      });
    } catch (err) {
      console.error("Color swatches load error:", err);
    }
  }

  function initColorSwatches(context = document) {
    const swatchBlocks = context.querySelectorAll("[data-product-swatch]");
    if (!swatchBlocks.length) return;
    swatchBlocks.forEach(renderSwatchesForHolder);
  }

  // --- Mutation observer with auto-kill after idle ---
  let observer = null;
  let idleTimer = null;

  function startObserver() {
    if (observer) return; // already running

    observer = new MutationObserver(mutations => {
      // Reset idle timer on each mutation
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }, OBSERVER_IDLE_TIMEOUT);

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue; 
          if (node.matches && node.matches("[data-product-swatch]")) {
            renderSwatchesForHolder(node);
          }
          if (node.querySelectorAll) {
            const found = node.querySelectorAll("[data-product-swatch]");
            if (found.length) found.forEach(renderSwatchesForHolder);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // safety: also ensure idle timer is set initially
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      if (observer) {
        observer.disconnect();
        observer = null;
        // console.info("Color swatch observer stopped for performance ✅");
      }
    }, OBSERVER_IDLE_TIMEOUT);
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", () => {
    initColorSwatches(document);
    startObserver();
  });

  /* --- Quick Add to Cart for product grid ---
  document.addEventListener("DOMContentLoaded", () => {
    const quickAddForms = document.querySelectorAll("[data-quick-add-form]");

    quickAddForms.forEach(form => {
      // Initialize Impulse AJAX product handler
      new theme.AjaxProduct(form, ".quick-add__btn", { scopedEventId: "quick-add" });

      const radios = form.querySelectorAll('input[name="variant"]');
      const hiddenInput = form.querySelector('input[name="id"]');

      radios.forEach(radio => {
        radio.addEventListener("change", () => {
          if (radio.disabled) return;

          hiddenInput.value = radio.value;

          // Add a loading indicator
          form.classList.add("is-loading");

          // Automatically trigger form submit (which theme.AjaxProduct intercepts)
          form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        });
      });

      // Handle cart drawer update after item is added
      form.addEventListener("ajaxProduct:added", event => {
        form.classList.remove("is-loading");

        // Open drawer if Impulse drawer function exists
        if (theme.cart && theme.cart.openDrawer) {
          theme.cart.openDrawer();
        } else {
          // Fallback: manually reload the drawer section
          fetch("/?sections=cart-drawer")
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newDrawer = doc.querySelector("#cart-drawer");
              const currentDrawer = document.querySelector("#cart-drawer");
              if (newDrawer && currentDrawer) {
                currentDrawer.innerHTML = newDrawer.innerHTML;
                document.body.classList.add("cart-drawer-open");
              }
            });
        }
      });
    });
  }); **/
  
  /***Size Guide***/
    document.addEventListener('DOMContentLoaded', function () {
      const toggleButton = document.querySelector('[data-toggle-sizeguide]');
      const drawer = document.getElementById('sizeguide-slide');
      const closeButton = document.querySelector('[data-close-sizeguide]');

      if (toggleButton && drawer) {
        toggleButton.addEventListener('click', () => {
          drawer.classList.add('open');
          drawer.setAttribute('aria-hidden', 'false');
        });
      }

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          drawer.classList.remove('open');
          drawer.setAttribute('aria-hidden', 'true');
        });
      }

      // Close on click outside
      document.addEventListener('click', (e) => {
        if (drawer.classList.contains('open') && !drawer.contains(e.target) && !toggleButton.contains(e.target)) {
          drawer.classList.remove('open');
        }
      });
    });


  /***Tabs within size guide***/

      document.addEventListener('DOMContentLoaded', function () {
        
        const tabLinks = document.querySelectorAll('.tab-link');
        const tabContents = document.querySelectorAll('.tab-content');

        tabLinks.forEach(link => {
          link.addEventListener('click', () => {
            const tabId = link.getAttribute('data-tab');

            tabLinks.forEach(l => l.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));

            link.classList.add('active');
            document.getElementById(`tab-${tabId}`).classList.add('active');
          });
        });
      });
 
  // Force remove via the existing QtySelector (no custom AJAX)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart__remove a, [data-item-remove], [data-cart-remove]');
    if (!btn) return;

    e.preventDefault();

    const item  = btn.closest('.cart__item');
    const input = item && item.querySelector('.js-qty__num');
    const key   = (btn.dataset.id) || (input && input.dataset.id);

    if (!key) {
      // No key? Hard fallback.
      window.location.href = btn.getAttribute('href');
      return;
    }

    const detail = [key, 0, item || document.body];

    // 1) Dispatch all likely names on both targets
    const targets = [document, document.documentElement];
    const names = ['cart:quantity', 'cart:quantity-page', 'cart:quantity-drawer', 'cart:quantitynull'];
    targets.forEach(t => names.forEach(n => t.dispatchEvent(new CustomEvent(n, { detail }))));

    // 2) Also drive the QtySelector path directly (if present)
    if (input) {
      input.value = '0';
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, { passive: false });

  /* Toggle quick add options visibility
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quick-add__toggle-btn');
    const openOptions = document.querySelector('[data-quick-add-options].show');

    // --- 1. Toggle button clicked ---
    if (btn) {
      const form = btn.closest('form');
      const options = form?.querySelector('[data-quick-add-options]');
      if (!options) return;

      const isShown = options.classList.toggle('show');
      document.body.classList.toggle('no-scroll-quick', isShown);
      return;
    }

    // --- 2. Click outside any open selector ---
    if (openOptions && !e.target.closest('[data-quick-add-options]') && !e.target.closest('.quick-add__toggle-btn')) {
      openOptions.classList.remove('show');
      document.body.classList.remove('no-scroll-quick');
    }
  });

  // --- 3. On product added via AJAX ---
  document.addEventListener('ajaxProduct:added', () => {
    const openOptions = document.querySelector('[data-quick-add-options].show');
    if (openOptions) openOptions.classList.remove('show');
    document.body.classList.remove('no-scroll-quick');
  }); */



})();

// --- Cart drawer fix ---
// Polls /cart.js after every ATC click and opens the drawer once the item
// count increases. Works regardless of what script makes the add (AjaxProduct,
// Swym, Elevar, etc.) since it checks the outcome, not the mechanism.
(function () {
  var POLL_MS = 250;
  var MAX_POLLS = 14; // up to ~3.5 s

  var cartCount = 0;
  var pollTimer = null;

  function openDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.classList.contains('drawer--is-open')) return;
    // Dispatch the event CartDrawer already listens for (buildCart + open)
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    // Fallback: force the CSS classes if CartDrawer didn't respond
    setTimeout(function () {
      var d = document.getElementById('CartDrawer');
      if (!d || d.classList.contains('drawer--is-open')) return;
      d.classList.add('is-transitioning');
      d.offsetWidth;
      d.classList.add('drawer--is-open');
      document.documentElement.classList.add('js-drawer-open');
    }, 50);
  }

  function poll(baseline, remaining) {
    if (remaining <= 0) return;
    var drawer = document.getElementById('CartDrawer');
    if (drawer && drawer.classList.contains('drawer--is-open')) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) { scheduleNext(baseline, remaining); return; }
        cartCount = data.item_count;
        if (cartCount > baseline) {
          openDrawer();
        } else {
          scheduleNext(baseline, remaining);
        }
      })
      .catch(function () { scheduleNext(baseline, remaining); });
  }

  function scheduleNext(baseline, remaining) {
    pollTimer = setTimeout(function () { poll(baseline, remaining - 1); }, POLL_MS);
  }

  function setup() {
    // Snapshot cart count at page load so we have a clean baseline
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) cartCount = data.item_count; })
      .catch(function () {});

    var form = document.querySelector('.product-single__form');
    if (!form) return;

    var atcBtn = form.querySelector('[data-add-to-cart]');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', function () {
      if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
      var baseline = cartCount;
      // Small initial delay so the add request has time to fire
      pollTimer = setTimeout(function () { poll(baseline, MAX_POLLS); }, POLL_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

// --- Quick Add to Cart for product grid (resilient + observer) ---
// Quick Add + S&D-aware re-init
(function () {
  // --- wait until theme.AjaxProduct is ready
  function whenAjaxProductReady(cb, tries = 60, delay = 150) {
    if (window.theme && typeof theme.AjaxProduct === 'function') return cb();
    if (tries <= 0) return console.warn('[QuickAdd] theme.AjaxProduct not found.');
    setTimeout(() => whenAjaxProductReady(cb, tries - 1, delay), delay);
  }

  // --- init quick add within a root (idempotent via data-qa-init)
  function initQuickAddWithin(root = document) {
    const forms = root.querySelectorAll('[data-quick-add-form]:not([data-qa-init])');
    forms.forEach(form => {
      form.setAttribute('data-qa-init', 'true');

      // 1) Init Impulse AjaxProduct (guard)
      try { new theme.AjaxProduct(form, '.quick-add__btn', { scopedEventId: 'quick-add' }); }
      catch (e) { console.warn('[QuickAdd] AjaxProduct init failed:', e); }

      const hiddenInput = form.querySelector('input[name="id"]');

      // 2) Variant change -> submit
      form.addEventListener('change', ev => {
        const input = ev.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.name !== 'variant' || input.disabled) return;

        if (hiddenInput) hiddenInput.value = input.value;
        form.classList.add('is-loading');

        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } catch (err) {
          console.error('[QuickAdd] submit failed:', err);
          form.classList.remove('is-loading');
        }
      });

      // 3) After added -> open drawer (or fallback reload)
      form.addEventListener('ajaxProduct:added', () => {
        form.classList.remove('is-loading');

        if (window.theme?.cart?.openDrawer) {
          try { theme.cart.openDrawer(); return; } catch (e) { /* fallback below */ }
        }
        fetch('/?sections=cart-drawer')
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('#cart-drawer');
            const cur  = document.querySelector('#cart-drawer');
            if (next && cur) {
              cur.innerHTML = next.innerHTML;
              document.body.classList.add('cart-drawer-open');
            }
          })
          .catch(err => console.error('[QuickAdd] drawer fallback failed:', err));
      });

      // Optional: clear loader on theme error
      form.addEventListener('ajaxProduct:error', () => {
        form.classList.remove('is-loading');
      });
    });
  }

  // --- observe #CollectionAjaxContent for S&D replacements
  function startCollectionObserver() {
    const host = document.getElementById('CollectionAjaxContent') || document;
    const observer = new MutationObserver(muts => {
      // throttle to the next frame in case of batch updates
      let needsInit = false;
      for (const m of muts) {
        if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
          // re-init if new quick-add forms *or* the grid wrapper was swapped
          if (
            host.querySelector('[data-quick-add-form]:not([data-qa-init])') ||
            Array.from(m.addedNodes).some(n => n.nodeType === 1 && (
              n.matches?.('.collection-grid__wrapper, [data-quick-add-form]') ||
              n.querySelector?.('.collection-grid__wrapper, [data-quick-add-form]')
            ))
          ) { needsInit = true; break; }
        }
      }
      if (needsInit) {
        requestAnimationFrame(() => {
          initQuickAddWithin(host);
        });
      }
    });

    observer.observe(host, { childList: true, subtree: true });
    return observer;
  }

  // --- bootstrap
  document.addEventListener('DOMContentLoaded', () => {
    whenAjaxProductReady(() => {
      // initial bind on first paint
      const root = document.getElementById('CollectionAjaxContent') || document;
      initQuickAddWithin(root);
      // watch for Search & Discovery updates
      startCollectionObserver();
    });
  });

  // --- (Nice-to-have) if the app fires custom events after refreshes:
  // document.addEventListener('collection:refreshed', () => {
  //   const root = document.getElementById('CollectionAjaxContent') || document;
  //   initQuickAddWithin(root);
  // });
})();

// --- Quick Add modal for mobile (cloning grid) ---
(function () {
  'use strict';

  // --- Config --------------------------------------------------------------
  var MOBILE_MQ = '(max-width: 767px)';
  var TOGGLE_BTN_SEL = '.quick-add__toggle-btn';
  var GRID_SEL = '.quick-add-grid';
  var FORM_SEL = '[data-quick-add-form]'; // your theme’s quick-add form
  var OPEN_CLASS = 'qa-modal--open';

  function isMobile () { return window.matchMedia && window.matchMedia(MOBILE_MQ).matches; }
  function removeAllIds(root){
    root.querySelectorAll('[id]').forEach(function(el){ el.removeAttribute('id'); });
    if (root.hasAttribute('id')) root.removeAttribute('id');
  }
  function killIfOpen () {
    var open = document.querySelector('.qa-modal');
    if (open) {
      open.remove();
      document.documentElement.classList.remove('qa-no-scroll');
      document.body.classList.remove('qa-no-scroll');
      window.removeEventListener('keydown', escClose);
    }
  }
  function escClose (e) {
    if (e.key === 'Escape') killIfOpen();
  }

  function initAjaxOnClonedForms(root) {
    if (window.theme && typeof theme.AjaxProduct === 'function') {
      root.querySelectorAll(FORM_SEL).forEach(function(form) {
        new theme.AjaxProduct(form, '.quick-add__btn', { scopedEventId: 'quick-add-modal' });
      });
    }
  }

  function wireVariantAutoSubmit(root) {
    root.querySelectorAll(FORM_SEL).forEach(function(form){
      var radios = form.querySelectorAll('input[name="variant"]');
      var hidden = form.querySelector('input[name="id"]');
      if (!radios.length || !hidden) return;

      radios.forEach(function(radio){
        radio.addEventListener('change', function(){
          if (radio.disabled) return;
          hidden.value = radio.value;
          form.classList.add('is-loading');
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      });
    });
  }

  // Build + mount modal with a cloned grid
  function openQuickAddModal(originalGrid) {
    killIfOpen(); 

    var clone = originalGrid.cloneNode(true);
    // Avoid duplicate IDs when cloning
    removeAllIds(clone);

    var modal = document.createElement('div');
    modal.className = 'qa-modal ' + OPEN_CLASS;
    modal.innerHTML = '' +
      '<div class="qa-modal__overlay" data-qa-close></div>' +
      '<div class="qa-modal__panel" role="dialog" aria-modal="true" aria-label="Quick add">' +
        '<button class="qa-modal__close" type="button" aria-label="Close" data-qa-close>&times;</button>' +
      '</div>';

    modal.querySelector('.qa-modal__panel').appendChild(clone);

    document.body.appendChild(modal);
    document.documentElement.classList.add('qa-no-scroll');
    document.body.classList.add('qa-no-scroll');
    window.addEventListener('keydown', escClose);

    modal.addEventListener('click', function(e){
      if (e.target.closest('[data-qa-close]')) killIfOpen();
    });

    const options = modal.querySelector('.quick-add__options');
    if (options) options.classList.add('show');    

    initAjaxOnClonedForms(modal);
    wireVariantAutoSubmit(modal);

     document.addEventListener('ajaxProduct:added', killIfOpen, { once: true });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest(TOGGLE_BTN_SEL);
    if (!btn) return;

    if (!isMobile()) return; 

    var grid = btn.closest(GRID_SEL);
    if (!grid) return;

    e.preventDefault();
    openQuickAddModal(grid);
  });

})();






